import { apiInterceptor } from './axios';
import { API_URL } from 'shared/api/Constants';

export const saveMFSHAnswersAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.SAVE_MFSH_ANSWERS}/${data.patientId}`, data).then((response: any) => {
    return response;
  });
};

export const getMFSHStatusAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.GET_MFSH_STATUS}/${patientId}`).then((response: any) => {
    return response;
  });
};

export const getMFSHLinkAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.GET_MFSH_LINK}/${patientId}`).then((response: any) => {
    return response;
  });
};

export const downloadMCATReportAPI = async (userId: number) => {
  const response = await apiInterceptor.get(`${API_URL.DOWNLOAD_MCAT_REPORT}/${userId}`);
  return response;
};
